import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { deleteFlaggedMessage, getFlaggedMessages, updateFlaggedMessage } from 'actions/conversation_admin';
import Date from 'components/Presentation/Date/Date';
import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { Button } from '@haldor/ui';
import Block, { BlockWrapper } from 'UI/Elements/Block';
import { setPageTitle } from 'actions/header';

var FlaggedConversations = /*#__PURE__*/function (_Component) {
  _inherits(FlaggedConversations, _Component);

  var _super = _createSuper(FlaggedConversations);

  function FlaggedConversations(props) {
    var _this;

    _classCallCheck(this, FlaggedConversations);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('nav_flagged-messages'));
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(FlaggedConversations, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getData();
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this2 = this;

      this.setState({
        loading: true
      });
      this.props.getFlaggedMessages().then(function () {
        _this2.setState({
          loading: false
        });
      });
    }
  }, {
    key: "softDeleteMessage",
    value: function softDeleteMessage(flag) {
      var _this3 = this;

      this.props.deleteFlaggedMessage(flag.id).then(function () {
        _this3.getData();
      });
    }
  }, {
    key: "removeFlag",
    value: function removeFlag(flag) {
      var _this4 = this;

      flag.status = 'CLOSED';
      this.props.updateFlaggedMessage(flag).then(function () {
        _this4.getData();
      });
    }
  }, {
    key: "headerContent",
    value: function headerContent(flag) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left',
          color: '#535353',
          fontSize: '0.9em'
        }
      }, this.props.translate('reported-by'), ": ", flag.reporter.firstName + " " + flag.reporter.lastName), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Date, null, Moment(flag.created))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }, {
    key: "content",
    value: function content(flag) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, this.props.translate('reason')), /*#__PURE__*/React.createElement("p", null, flag.reason), /*#__PURE__*/React.createElement("span", {
        style: {
          "float": 'right',
          color: '#535353',
          fontSize: '0.9em',
          marginTop: '1em'
        }
      }, this.props.translate('written-by'), ": ", flag.reporter.firstName + " " + flag.reporter.lastName)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1em'
        }
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('message')), /*#__PURE__*/React.createElement("p", null, flag.message.text), /*#__PURE__*/React.createElement("span", {
        style: {
          "float": 'right',
          color: '#535353',
          fontSize: '0.9em',
          marginTop: '1em'
        }
      }, this.props.translate('written-by'), ": ", flag.sender.firstName + " " + flag.sender.lastName)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }, {
    key: "footerContent",
    value: function footerContent(flag) {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "spacing"
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          margin: '5px'
        },
        onClick: function onClick() {
          _this5.softDeleteMessage(flag);
        }
      }, this.props.translate('remove-message')), /*#__PURE__*/React.createElement(Button, {
        style: {
          margin: '5px'
        },
        type: "secondary",
        onClick: function onClick() {
          _this5.removeFlag(flag);
        }
      }, this.props.translate('remove-flagged-message')));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var flagged = [];

      if (this.props.flagged != null && this.props.flagged.length > 0) {
        flagged = _toConsumableArray(this.props.flagged);
        flagged.sort(function (a, b) {
          return a.id < b.id ? 1 : -1;
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: 3
      }, flagged.map(function (flag) {
        return /*#__PURE__*/React.createElement(Block, {
          key: flag.id,
          headerContent: _this6.headerContent(flag),
          content: _this6.content(flag),
          footerContent: _this6.footerContent(flag)
        });
      })), this.props.flagged.length == 0 ? /*#__PURE__*/React.createElement("div", null, this.props.translate('no-flagged-messages-found')) : null);
    }
  }]);

  return FlaggedConversations;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    flagged: state.ConversationAdmin.flagged
  };
}

export default connect(mapStateToProps, {
  getFlaggedMessages: getFlaggedMessages,
  updateFlaggedMessage: updateFlaggedMessage,
  deleteFlaggedMessage: deleteFlaggedMessage,
  setPageTitle: setPageTitle
})(FlaggedConversations);